module.exports = __webpack_public_path__ + "static/media/flexit-print-logo.1340bbd7.png";